import { Component, OnInit, Input } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit {
  @Input('breadCrumbList') breadCrumbList: string[];
  constructor(private location: Location) { }

  ngOnInit() {
   
  }
  back1() {
    this.location.back(); // <-- go back to previous location on cancel
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src198490057/src/src/app/common/bread-crumb/bread-crumb.component.ts